var exports = {
  "n": "xe533113f--13fd32--link",
};

module.exports = exports;
